module.exports = __webpack_public_path__ + "img/badge.a86eba83.svg";